export interface searchProjectAdderss {
  contact_id: number;
  commercial_client_id?: number;
  domestic_client_id?: number;
  project_type: string;
  address: string;
  city: string;
  post_code: string;
}

export interface serviceType {
  id: number;
  name: string;
}

export interface SubscriptionDetails {
  subscription_id: number;
  order_number: number;
  subscription_name: string;
  monthly_subscription_amount: number;
  feature?: [
    {
      feature_name: string;
    },
  ];
  is_free: 1 | 0;
  tax_percentage: number;
  license_count: number;
  used_count: number;
  available_count: number;
}

export interface Progress {
  progress_id: number;
  folder_id: number;
  stage_no: number;
  description: string;
  status: string;
  percentage: number;
  date: string;
}
export interface SubFolderDocument {
  id: number;
  sub_folder_id: number;
  title: string;
  path: string;
  update_at: string;
}

export interface Project {
  project: string;
  project_id: number;
  job_number: number;
  contact_id: number;
  subscription_id: number;
  commercial_client_project_info_id?: number;
  domestic_client_info_id?: number;
  project_type: string;
  description: string;
  end_of_date: string | null;
  service_type_ids: string;
  status: string;
  user_id: number;
  address: string;
  city: string;
  post_code: string;
  service_type: ServiceType[];
  contact: ProjectBasicContact[];
  subscription_name: string;
  order_number: number;
  company_name: string;
  license_with_key_id: number;
  project_for: string;
  project_start_date: string;
  project_end_date: string;
  this_project_active: 1 | 0;
  show_reminder?: boolean;
  remaider_day_count?: number | null;
}

export const mapProject = (data: any): Project => {
  if (!data) {
    throw new Error("Invalied ProjectContact type");
  }

  const project: Project = {
    project: "",
    project_id: data.project_id,
    job_number: data.job_number,
    contact_id: data.contact_id,
    subscription_id: data.subscription_id,
    commercial_client_project_info_id:
      data.project_type === "CP" ? data.client_id : null,
    domestic_client_info_id: data.project_type !== "CP" ? data.client_id : null,
    project_type: data.project_type === "CP" ? "Commercial" : "Domestic",
    description: data.description,
    end_of_date: data.end_of_date ?? null,
    service_type_ids: data.service_type_ids,
    status: data.status,
    user_id: data.user_id,
    address: data.address,
    city: data.city,
    post_code: data.post_code,
    service_type: mapServiceTypes(data.service_type),
    contact: mapProjectBasicContacts(data.contact),

    subscription_name: data.subscription_name,
    order_number: data.order_number,
    company_name: data.company_name,
    license_with_key_id: data.license_with_key_id,
    project_for: data.project_for,
    project_start_date: data.project_start_date,
    project_end_date: data.project_end_date,
    this_project_active: data.this_project_active,
    show_reminder: data.show_remaider,
    remaider_day_count: data.remaider_day_count,
  };

  return project;
};

export const mapProjects = (data: any[]): Project[] => {
  if (!Array.isArray(data)) {
    throw new Error("Invalid Project data");
  }

  return data.map(mapProject);
};

export interface ProjectBasicContact {
  project_id: number;
  first_name: string;
  last_name: string;
  profile_image: string;
  mobile: string;
  landline: string;
  email: string;
  address: string;
  city: string;
  post_code: string;
  role_name: string;
  by: string;
  id: number;
  icChecked: boolean;
  can_edit?: 1 | 0;
  can_view?: 1 | 0;
}

export const mapProjectBasicContact = (data: any): ProjectBasicContact => {
  if (!data) {
    throw new Error("Invalied Project Contact type");
  }

  const projectBasicContact: ProjectBasicContact = {
    project_id: data.project_id,
    first_name: data.first_name,
    last_name: data.last_name,
    profile_image: data.profile_image,
    mobile: data.mobile,
    landline: data.landline,
    email: data.email,
    address: data.address,
    city: data.city,
    post_code: data.post_code,
    role_name: data.role_name,
    by: data.by,
    id: data.id,
    icChecked: false,
    can_edit: data.can_edit,
    can_view: data.can_view,
  };

  return projectBasicContact;
};

export const mapProjectBasicContacts = (data: any[]): ProjectBasicContact[] => {
  if (!Array.isArray(data)) {
    throw new Error("Invalid Project Contact data");
  }

  return data.map(mapProjectBasicContact);
};

export interface ServiceType {
  id: number;
  name: string;
}

export const mapServiceType = (data: any): ServiceType => {
  if (!data) {
    throw new Error("Invalied employee type");
  }

  const serviceType: ServiceType = {
    id: data.id,
    name: data.name,
  };

  return serviceType;
};

export const mapServiceTypes = (data: any[]): ServiceType[] => {
  if (!Array.isArray(data)) {
    throw new Error("Invalid Service Type data");
  }

  return data.map(mapServiceType);
};
